import { ArticleModel, IArticle } from '../../prisma-xs/models/article.model';
import { IPragmaResponse } from '../../prisma-xs/models/product-xs.model';
import { PragmaConstant } from '../models/pragma.constant';

export const getSmallestArticle = (articles: IArticle[]) => {
  return articles.reduce(
    (acc, loc) =>
      (acc.widget.height + acc.widget.width) < (loc.widget.height + loc.widget.width) ? acc : loc
  );
};

export const findTheMaximumValueInArrayForAttribute = (items: IArticle[], attribute: string): number => {
  return Math.max.apply(Math, items.map((o) => o.widget[attribute] ));
};

export const findTheMinimumValueInArrayForAttribute = (items: IArticle[], attribute: string): number => {
  return Math.min.apply(Math, items.map((o) => o.widget[attribute] ));
};


export const generateImageUrl = (image: string) => {
  return `${PragmaConstant.KITS_IMAGE_LOCATION}/${image}.${PragmaConstant.KITS_IMAGE_TYPE}`;
};

export const generate2DImageUrl = (image: string, type: 'support'|'cover') => {
  return `${PragmaConstant.KITS_2D_IMAGE_LOCATION}/${image}_${type}.${PragmaConstant.KITS_IMAGE_TYPE}`;
};

export const mapProductToArticlePragma = (product: IPragmaResponse) => {
  const article = new ArticleModel();
  article.productId = product.productId;
  article.productType = product.typeDescription;
  article.eNumber = product.eNumber;
  article.ref = product.reference;
  article.description = product.description;
  article.kitType = product.kitType;
  article.kitTypeId = product.kitTypeId;
  article.picture2D = generate2DImageUrl(`${product.reference}`, 'support');
  article.pictures = [
    generate2DImageUrl(`${product.reference}`, 'support'),
    generate2DImageUrl(`${product.reference}`, 'cover')
  ];
  article.picture3D = generateImageUrl(`${product.reference}`);
  article.rules = product.rules;
  article.widget = {
    selected: false,
    left: 1,
    top: 1,
    height: product.rows,
    width: product.fileds
  };
  article.price = product.price;
  article.status = product.status;

  return article;
};
